












import Vue from "vue";

// Components
import ReportTableCard from "@/views/App/CashFlow/UsersBalance/ReportTableCard.vue";

// Model
import { UsersBalanceReportTotals } from "@/model/data/usersBalance/UsersBalanceReportTotals";
import { UsersBalanceReportEntry } from "@/model/data/usersBalance/UsersBalanceReportEntry";

export default Vue.extend({
    components: {
        ReportTableCard,
    },
    data() {
        return {};
    },
    props: {
        loading: { type: Boolean, default: false },
        usersBalanceReportTotals: { type: UsersBalanceReportTotals },
    },
    computed: {
        fakeUsersBalanceReportEntries() {
            var res: UsersBalanceReportEntry[] = [];
            var fakeEntry: UsersBalanceReportEntry = new UsersBalanceReportEntry();

            this.usersBalanceReportTotals.cashIn.forEach((item) => {
                fakeEntry.cashIn.push({ key: item.key, value: item.value });
            });
            this.usersBalanceReportTotals.cashOut.forEach((item) => {
                fakeEntry.cashOut.push({ key: item.key, value: item.value });
            });
            this.usersBalanceReportTotals.cashBalance.forEach((item) => {
                fakeEntry.cashBalance.push({ key: item.key, value: item.value });
            });
            this.usersBalanceReportTotals.manualDeposit.forEach((item) => {
                fakeEntry.manualDeposit.push({ key: item.key, value: item.value });
            });
            this.usersBalanceReportTotals.balance.forEach((item) => {
                fakeEntry.balance.push({ key: item.key, value: item.value });
            });

            res.push(fakeEntry);
            return res;
        },
    },
});
